import { generatePath } from 'react-router-dom';
import { TAG_TYPES } from '@app/api/tagTypes';
import { HTTP_METHODS } from '@app/configs/api';
import { LOAN_APPLICATIONS_ENDPOINTS } from '@app/configs/api/loanApplications';
import { baseApi } from './baseApi';
export const loanApplicationsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getActiveLoans: builder.query({
            query: () => ({
                url: LOAN_APPLICATIONS_ENDPOINTS.activeLoans,
            }),
            providesTags: [TAG_TYPES.LOAN_APPLICATIONS],
        }),
        getPastLoans: builder.query({
            query: () => ({
                url: LOAN_APPLICATIONS_ENDPOINTS.allLoans,
                params: {
                    status: 'passed',
                },
            }),
            providesTags: [TAG_TYPES.LOAN_APPLICATIONS],
        }),
        createLoanApplication: builder.mutation({
            query: (data) => ({
                url: LOAN_APPLICATIONS_ENDPOINTS.createLoan,
                method: HTTP_METHODS.POST,
                body: data,
            }),
            invalidatesTags: [TAG_TYPES.LOAN_APPLICATIONS],
        }),
        getPaymentSchedule: builder.query({
            query: (id) => ({
                url: generatePath(LOAN_APPLICATIONS_ENDPOINTS.paymentSchedule, { id }),
            }),
            providesTags: [TAG_TYPES.LOAN_APPLICATIONS],
        }),
    }),
    overrideExisting: false,
});
export const { useGetActiveLoansQuery, useGetPastLoansQuery, useCreateLoanApplicationMutation, useGetPaymentScheduleQuery, } = loanApplicationsApi;
